import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { faClose, faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import { clsx } from 'clsx';

export const ValidationAlert = ({
  errors,
  onClear,
}: {
  errors: string[];
  onClear: () => void;
}) => {
  if (isEmpty(errors)) return null;

  return (
    <div className="flex gap-2 bg-[#FFE2E2] rounded-[10px] w-[480px] pl-4 pr-2 py-3.5">
      <FontAwesomeIcon
        icon={faExclamationCircle}
        className={clsx(sprinkles({ color: 'ERROR-100' }), 'pt-[3px]')}
      />
      <div className="flex flex-col">
        <Typography variant="body" size="large">
          Make sure you&rsquo;ve included Workouts and filled out the About tab
          before you package this into an Offer
        </Typography>
        <ul className="list-disc">
          {errors.map((error) => (
            <li key={error}>
              <Typography>{error}</Typography>
            </li>
          ))}
        </ul>
      </div>
      <FontAwesomeIcon
        icon={faClose}
        className={clsx(
          sprinkles({ color: 'B-100' }),
          'ml-auto pt-[3px] cursor-pointer',
        )}
        onClick={onClear}
      />
    </div>
  );
};
